import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function BannerOtimizeNegocio({
    headingBold,
    headingText,
    buttonText,
    buttonUrl = "#",
}) {
    const { openModal } = useModal();
    return (
        <div className="bg-[rgb(168,0,228)] bg-[url(../assets/banner-otimize-mobile.png)] md:bg-[url(../assets/banner-otimize.png)] bg-no-repeat bg-cover bg-left text-white px-8 md:px-30 min-h-[500px] flex flex-col justify-end md:justify-center">
            <div className="container mx-auto py-4 md:py-24">
                <section className="max-w-[600px] w-full ms-auto space-y-8 font-inter-regular flex flex-col items-center md:items-start">
                    <h2 className="text-2xl md:text-[40px] leading-[1.4] text-center md:text-left px-8 md:px-0">
                        <strong className="font-inter-extrabold">{headingBold}</strong>
                        {headingText}
                    </h2>
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="rounded-full bg-white text-[#A800E4] py-3 px-6 w-fit text-xl font-bold hover:scale-105 transition-all duration-300 cursor-pointer inline-block mb-6 md:mb-0"
                    >
                        {buttonText}
                    </button>
                </section>
            </div>
        </div>
    );
}
